import { render, staticRenderFns } from "./submit-successfully.vue?vue&type=template&id=15731ffc"
import script from "./submit-successfully.vue?vue&type=script&lang=js"
export * from "./submit-successfully.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports